export default __webpack_public_path__ + "static/media/192.aa248db5.svg";